<template>
  <!-- eslint-disable -->
  <!--        <router-link to="/store" class="cyber-sale-banner d-flex justify-content-center align-items-center py-2">-->
  <!--            <svg xmlns="http://www.w3.org/2000/svg" class="mr-2" width="32" height="32" viewBox="0 0 32 32"><title>discount-2</title><g stroke-linecap="square" stroke-linejoin="miter" stroke-width="2" fill="none" stroke="#30a322" stroke-miterlimit="10"><line x1="11" y1="21" x2="21" y2="11" stroke="#30a322"></line> <circle cx="12" cy="12" r="2" stroke="#30a322"></circle> <circle cx="20" cy="20" r="2" stroke="#30a322"></circle> <polygon points="27,21 31,16 27,11 27,5 21,5 16,1 11,5 5,5 5,11 1,16 5,21 5,27 11,27 16,31 21,27 27,27 "></polygon></g></svg> <p class="mb-0"> Our Cyber Week Sale has begun! <span>Browse the store <svg xmlns="http://www.w3.org/2000/svg" class="ml-1" width="16" height="16" viewBox="0 0 16 16"><title>arrow-right</title><g fill="#30a322"><path d="M10.707,2.293A1,1,0,0,0,9.293,3.707L12.586,7H1A1,1,0,0,0,1,9H12.586L9.293,12.293a1,1,0,1,0,1.414,1.414l5-5a1,1,0,0,0,0-1.414Z" fill="#30a322"></path></g></svg></span></p>-->
  <!--        </router-link>-->

  <!-- Navigation Start -->
  <nav class="navbar navbar-expand-xl sticky-top">
    <div
      class="container large d-flex flex-row justify-content-xl-between align-items-center navbar-wrapper mx-3"
    >
      <div class="d-flex flex-row align-items-center">
        <div class="nav-logo mr-3 mr-lg-4 my-1">
          <router-link to="/">
            <img src="@/assets/img/branding/nav-logo.png" lazy />
          </router-link>
        </div>

        <div class="collapse navbar-collapse" id="navbarContent">
          <ul class="navbar-nav">
            <li class="nav-item nav-login">
              <router-link to="/login" class="nav-link"
                >Login / Register</router-link
              >
            </li>
            <li class="nav-item">
              <router-link to="/play" class="nav-link">Download</router-link>
            </li>
            <!--                            <li class="nav-item px-3">-->
            <!--                                <router-link to="/credits" class="nav-link">Store</router-link>-->
            <!--                            </li>-->
            <!--                            <li class="nav-item px-3">-->
            <!--                                <router-link to="/vote" class="nav-link">Vote</router-link>-->
            <!--                            </li>-->
            <li class="nav-item">
              <a
                class="nav-link"
                href="https://discord.com/invite/nrpk"
                target="_blank"
                >Discord</a
              >
            </li>
          </ul>
        </div>
      </div>
      <div class="d-flex align-items-center justify-content-end">
        <div
          v-if="!$store.getters.isLoggedIn"
          class="authenticated-actions ml-3"
        >
          <div class="dropdown">
            <a
              class="dropdown-toggle text-white d-flex align-items-center"
              href="#"
              role="button"
              id="userMenu"
              data-bs-toggle="dropdown"
              aria-expanded="false"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 24 24"
                height="16"
                width="16"
                class="mr-0 mr-md-2 flex-shrink-0"
              >
                <g
                  fill="currentColor"
                  stroke-linecap="square"
                  stroke-linejoin="miter"
                  stroke-miterlimit="10"
                >
                  <circle
                    cx="12"
                    cy="5.5"
                    r="4.5"
                    fill="none"
                    stroke="currentColor"
                    stroke-width="2"
                  ></circle>
                  <path
                    d="M12,14c-4.971,0-9,4.029-9,9H21c0-4.971-4.029-9-9-9Z"
                    fill="none"
                    stroke="currentColor"
                    stroke-width="2"
                  ></path>
                </g>
              </svg>
              <span class="d-none d-md-block mb-0 mr-2">Account</span>
            </a>
            <ul
              class="dropdown-menu dropdown-menu-end"
              aria-labelledby="userMenu"
            >
              <li class="bg-transparent py-2 px-0">
                <router-link class="dropdown-item bg-transparent" to="/login">
                  <button
                    class="btn primary font-weight-bold text-white w-100 d-flex align-items-center justify-content-center"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 24 24"
                      height="18"
                      width="18"
                      class="mr-2 flex-shrink-0"
                    >
                      <g
                        fill="currentColor"
                        stroke-linecap="square"
                        stroke-linejoin="miter"
                        stroke-miterlimit="10"
                      >
                        <circle
                          cx="10"
                          cy="5.5"
                          r="4.5"
                          fill="none"
                          stroke="currentColor"
                          stroke-width="3"
                        ></circle>
                        <path
                          d="M13,14.512c-.938-.332-1.948-.512-3-.512C5.029,14,1,18.029,1,23H14"
                          fill="none"
                          stroke="currentColor"
                          stroke-width="3"
                        ></path>
                        <polyline
                          points="18 14 22 18 18 22"
                          fill="none"
                          stroke="currentColor"
                          stroke-width="3"
                        ></polyline>
                        <polyline
                          points="14 18 22 18 21 18"
                          fill="none"
                          stroke="currentColor"
                          stroke-width="3"
                        ></polyline>
                      </g>
                    </svg>
                    Login
                  </button>
                </router-link>
              </li>
              <li>
                <router-link class="dropdown-item" to="/account">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 24 24"
                    height="24"
                    width="24"
                    class="mr-2 flex-shrink-0"
                  >
                    <g
                      fill="currentColor"
                      stroke-linecap="square"
                      stroke-linejoin="miter"
                      stroke-miterlimit="10"
                    >
                      <circle
                        cx="12"
                        cy="12"
                        r="3"
                        fill="none"
                        stroke="currentColor"
                        stroke-width="2"
                      ></circle>
                      <path
                        d="m22,12h0c0-.757-.455-1.44-1.154-1.731l-1.164-.485c-.099-.343-.219-.678-.36-1.001-.198-.453-.192-.969-.004-1.426l.16-.389c.288-.7.127-1.504-.408-2.04h0c-.535-.535-1.34-.696-2.04-.408l-1.162.479c-.518-.287-1.073-.515-1.654-.682l-.485-1.164c-.291-.699-.974-1.154-1.731-1.154h0c-.757,0-1.44.455-1.731,1.154l-.485,1.164c-.581.167-1.135.395-1.654.682l-1.162-.479c-.7-.288-1.504-.127-2.04.408h0c-.535.535-.696,1.34-.408,2.04l.479,1.162c-.287.518-.515,1.073-.682,1.654l-1.164.485c-.699.291-1.154.974-1.154,1.731h0c0,.757.455,1.44,1.154,1.731l1.164.485c.167.581.395,1.135.682,1.654l-.479,1.162c-.288.7-.127,1.504.408,2.04h0c.535.535,1.34.696,2.04.408l1.162-.479c.518.287,1.073.515,1.654.682l.485,1.164c.291.699.974,1.154,1.731,1.154h0c.757,0,1.44-.455,1.731-1.154l.485-1.164c.581-.167,1.135-.395,1.654-.682l1.162.479c.7.288,1.504.127,2.04-.408h0c.535-.535.696-1.34.408-2.04l-.479-1.162c.287-.518.515-1.073.682-1.654l1.164-.485c.699-.291,1.154-.974,1.154-1.731Z"
                        fill="none"
                        stroke="currentColor"
                        stroke-width="2"
                      ></path>
                    </g>
                  </svg>
                  Account Settings
                </router-link>
              </li>
              <li>
                <router-link class="dropdown-item" to="/register">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 24 24"
                    height="24"
                    width="24"
                    class="mr-2 flex-shrink-0"
                  >
                    <g
                      fill="currentColor"
                      stroke-linecap="square"
                      stroke-linejoin="miter"
                      stroke-miterlimit="10"
                    >
                      <path
                        d="M9,5H4c-1.105,0-2,.895-2,2v13c0,1.105,.895,2,2,2h13c1.105,0,2-.895,2-2v-5"
                        fill="none"
                        stroke="currentColor"
                        stroke-width="2"
                      ></path>
                      <line
                        x1="16"
                        y1="5"
                        x2="19"
                        y2="8"
                        fill="none"
                        stroke="currentColor"
                        stroke-width="2"
                        stroke-linecap="butt"
                      ></line>
                      <path
                        d="M11,16l-4,1,1-4L18.293,2.707c.391-.391,1.024-.391,1.414,0l1.586,1.586c.391,.391,.391,1.024,0,1.414l-10.293,10.293Z"
                        fill="none"
                        stroke="currentColor"
                        stroke-width="2"
                      ></path>
                    </g>
                  </svg>
                  Sign Up
                </router-link>
              </li>
              <ul class="dropdown-list-dark mt-2 py-2">
                <li>
                  <a
                    class="dropdown-item"
                    href="https://discord.com/invite/nrpk"
                    target="_blank"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 256 256"
                      height="24"
                      width="24"
                      class="mr-2 flex-shrink-0"
                    >
                      <g fill="currentColor">
                        <path fill="none" d="M0 0H256V256H0z"></path>
                        <path
                          d="M147,183.06a190.5,190.5,0,0,1-19,.94,190.5,190.5,0,0,1-19-.94L98.75,210.73a8.15,8.15,0,0,1-11,4.56l-67-29.7a8,8,0,0,1-4.55-9.24L45.77,60A8.08,8.08,0,0,1,52.31,54l36.06-5.92a8.1,8.1,0,0,1,9.21,6l5,19.63a192.32,192.32,0,0,1,50.88,0l5-19.63a8.1,8.1,0,0,1,9.21-6L203.69,54A8.08,8.08,0,0,1,210.23,60l29.53,116.37a8,8,0,0,1-4.55,9.24l-67,29.7a8.15,8.15,0,0,1-11-4.56Z"
                          opacity="0.000"
                        ></path>
                        <circle cx="92" cy="140" r="12"></circle>
                        <circle cx="164" cy="140" r="12"></circle>
                        <path
                          d="M153.44,73.69l5-19.63a8.1,8.1,0,0,1,9.21-6L203.69,54A8.08,8.08,0,0,1,210.23,60l29.53,116.37a8,8,0,0,1-4.55,9.24l-67,29.7a8.15,8.15,0,0,1-11-4.56L147,183.06"
                          fill="none"
                          stroke="currentColor"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          stroke-width="16"
                        ></path>
                        <path
                          d="M102.56,73.69l-5-19.63a8.1,8.1,0,0,0-9.21-6L52.31,54A8.08,8.08,0,0,0,45.77,60L16.24,176.35a8,8,0,0,0,4.55,9.24l67,29.7a8.15,8.15,0,0,0,11-4.56L109,183.06"
                          fill="none"
                          stroke="currentColor"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          stroke-width="16"
                        ></path>
                        <path
                          d="M80,78.31A178.94,178.94,0,0,1,128,72a178.94,178.94,0,0,1,48,6.31"
                          fill="none"
                          stroke="currentColor"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          stroke-width="16"
                        ></path>
                        <path
                          d="M176,177.69A178.94,178.94,0,0,1,128,184a178.94,178.94,0,0,1-48-6.31"
                          fill="none"
                          stroke="currentColor"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          stroke-width="16"
                        ></path>
                      </g>
                    </svg>
                    Discord
                  </a>
                </li>
                <li>
                  <router-link class="dropdown-item" to="/play">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 24 24"
                      height="24"
                      width="24"
                      class="mr-2 flex-shrink-0"
                    >
                      <g
                        fill="currentColor"
                        stroke-linecap="square"
                        stroke-linejoin="miter"
                        stroke-miterlimit="10"
                      >
                        <path
                          d="M2,16v4a2,2,0,0,0,2,2H20a2,2,0,0,0,2-2V16"
                          fill="none"
                          stroke="currentColor"
                          stroke-width="2"
                        ></path>
                        <line
                          x1="12"
                          y1="1"
                          x2="12"
                          y2="16"
                          fill="none"
                          stroke="currentColor"
                          stroke-width="2"
                          stroke-linecap="butt"
                        ></line>
                        <polyline
                          points="7 11 12 16 17 11"
                          fill="none"
                          stroke="currentColor"
                          stroke-width="2"
                        ></polyline>
                      </g>
                    </svg>
                    Download Client
                  </router-link>
                </li>
              </ul>
            </ul>
          </div>
        </div>
        <div
          v-if="$store.getters.isLoggedIn"
          class="authenticated-actions ml-3"
        >
          <div class="dropdown">
            <a
              class="dropdown-toggle text-white d-flex align-items-center"
              href="#"
              role="button"
              id="userMenu"
              data-bs-toggle="dropdown"
              aria-expanded="false"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 24 24"
                height="16"
                width="16"
                class="mr-2 flex-shrink-0"
              >
                <g
                  fill="currentColor"
                  stroke-linecap="square"
                  stroke-linejoin="miter"
                  stroke-miterlimit="10"
                >
                  <circle
                    cx="12"
                    cy="5.5"
                    r="4.5"
                    fill="none"
                    stroke="currentColor"
                    stroke-width="2"
                  ></circle>
                  <path
                    d="M12,14c-4.971,0-9,4.029-9,9H21c0-4.971-4.029-9-9-9Z"
                    fill="none"
                    stroke="currentColor"
                    stroke-width="2"
                  ></path>
                </g>
              </svg>
              <span class="mb-0 mr-2">{{ $store.state.user.name }}</span>
            </a>
            <ul
              class="dropdown-menu dropdown-menu-end"
              aria-labelledby="userMenu"
            >
              <li class="bg-transparent">
                <router-link
                  class="dropdown-item bg-transparent flex-column align-items-start"
                  to="/account"
                >
                  <p
                    class="mb-1 text-white font-weight-bold"
                    :class="
                      getRankSelector(
                        $store.state.user.privilege,
                        $store.state.user.memberRank
                      )
                    "
                  >
                    {{ $store.state.user.name }}
                  </p>
                  <p class="text-muted fs-6 mb-0 line-clamp-1">
                    {{ $store.state.user.email }}
                  </p>
                </router-link>
              </li>
              <li>
                <router-link class="dropdown-item" to="/account">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 24 24"
                    height="24"
                    width="24"
                    class="mr-2 flex-shrink-0"
                  >
                    <g
                      fill="currentColor"
                      stroke-linecap="square"
                      stroke-linejoin="miter"
                      stroke-miterlimit="10"
                    >
                      <circle
                        cx="12"
                        cy="12"
                        r="3"
                        fill="none"
                        stroke="currentColor"
                        stroke-width="2"
                      ></circle>
                      <path
                        d="m22,12h0c0-.757-.455-1.44-1.154-1.731l-1.164-.485c-.099-.343-.219-.678-.36-1.001-.198-.453-.192-.969-.004-1.426l.16-.389c.288-.7.127-1.504-.408-2.04h0c-.535-.535-1.34-.696-2.04-.408l-1.162.479c-.518-.287-1.073-.515-1.654-.682l-.485-1.164c-.291-.699-.974-1.154-1.731-1.154h0c-.757,0-1.44.455-1.731,1.154l-.485,1.164c-.581.167-1.135.395-1.654.682l-1.162-.479c-.7-.288-1.504-.127-2.04.408h0c-.535.535-.696,1.34-.408,2.04l.479,1.162c-.287.518-.515,1.073-.682,1.654l-1.164.485c-.699.291-1.154.974-1.154,1.731h0c0,.757.455,1.44,1.154,1.731l1.164.485c.167.581.395,1.135.682,1.654l-.479,1.162c-.288.7-.127,1.504.408,2.04h0c.535.535,1.34.696,2.04.408l1.162-.479c.518.287,1.073.515,1.654.682l.485,1.164c.291.699.974,1.154,1.731,1.154h0c.757,0,1.44-.455,1.731-1.154l.485-1.164c.581-.167,1.135-.395,1.654-.682l1.162.479c.7.288,1.504.127,2.04-.408h0c.535-.535.696-1.34.408-2.04l-.479-1.162c.287-.518.515-1.073.682-1.654l1.164-.485c.699-.291,1.154-.974,1.154-1.731Z"
                        fill="none"
                        stroke="currentColor"
                        stroke-width="2"
                      ></path>
                    </g>
                  </svg>
                  Account Settings
                </router-link>
              </li>
              <li>
                <a class="dropdown-item" href="#" @click.prevent="logout">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 24 24"
                    height="24"
                    width="24"
                    class="mr-2 flex-shrink-0"
                  >
                    <g
                      fill="currentColor"
                      stroke-linecap="square"
                      stroke-linejoin="miter"
                      stroke-miterlimit="10"
                    >
                      <line
                        x1="17"
                        y1="12"
                        x2="2"
                        y2="12"
                        fill="none"
                        stroke="currentColor"
                        stroke-width="2"
                        stroke-linecap="butt"
                      ></line>
                      <polyline
                        points="7 17 2 12 7 7"
                        fill="none"
                        stroke="currentColor"
                        stroke-width="2"
                      ></polyline>
                      <path
                        d="m10,2h9c1.105,0,2,.895,2,2v16c0,1.105-.895,2-2,2h-9"
                        fill="none"
                        stroke="currentColor"
                        stroke-width="2"
                      ></path>
                    </g>
                  </svg>
                  Log out
                </a>
              </li>
              <ul class="dropdown-list-dark mt-2 py-2">
                <li>
                  <a
                    class="dropdown-item"
                    href="https://discord.com/invite/nrpk"
                    target="_blank"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 256 256"
                      height="24"
                      width="24"
                      class="mr-2 flex-shrink-0"
                    >
                      <g fill="currentColor">
                        <path fill="none" d="M0 0H256V256H0z"></path>
                        <path
                          d="M147,183.06a190.5,190.5,0,0,1-19,.94,190.5,190.5,0,0,1-19-.94L98.75,210.73a8.15,8.15,0,0,1-11,4.56l-67-29.7a8,8,0,0,1-4.55-9.24L45.77,60A8.08,8.08,0,0,1,52.31,54l36.06-5.92a8.1,8.1,0,0,1,9.21,6l5,19.63a192.32,192.32,0,0,1,50.88,0l5-19.63a8.1,8.1,0,0,1,9.21-6L203.69,54A8.08,8.08,0,0,1,210.23,60l29.53,116.37a8,8,0,0,1-4.55,9.24l-67,29.7a8.15,8.15,0,0,1-11-4.56Z"
                          opacity="0.000"
                        ></path>
                        <circle cx="92" cy="140" r="12"></circle>
                        <circle cx="164" cy="140" r="12"></circle>
                        <path
                          d="M153.44,73.69l5-19.63a8.1,8.1,0,0,1,9.21-6L203.69,54A8.08,8.08,0,0,1,210.23,60l29.53,116.37a8,8,0,0,1-4.55,9.24l-67,29.7a8.15,8.15,0,0,1-11-4.56L147,183.06"
                          fill="none"
                          stroke="currentColor"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          stroke-width="16"
                        ></path>
                        <path
                          d="M102.56,73.69l-5-19.63a8.1,8.1,0,0,0-9.21-6L52.31,54A8.08,8.08,0,0,0,45.77,60L16.24,176.35a8,8,0,0,0,4.55,9.24l67,29.7a8.15,8.15,0,0,0,11-4.56L109,183.06"
                          fill="none"
                          stroke="currentColor"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          stroke-width="16"
                        ></path>
                        <path
                          d="M80,78.31A178.94,178.94,0,0,1,128,72a178.94,178.94,0,0,1,48,6.31"
                          fill="none"
                          stroke="currentColor"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          stroke-width="16"
                        ></path>
                        <path
                          d="M176,177.69A178.94,178.94,0,0,1,128,184a178.94,178.94,0,0,1-48-6.31"
                          fill="none"
                          stroke="currentColor"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          stroke-width="16"
                        ></path>
                      </g>
                    </svg>
                    Discord
                  </a>
                </li>
                <li>
                  <router-link class="dropdown-item" to="/play">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 24 24"
                      height="24"
                      width="24"
                      class="mr-2 flex-shrink-0"
                    >
                      <g
                        fill="currentColor"
                        stroke-linecap="square"
                        stroke-linejoin="miter"
                        stroke-miterlimit="10"
                      >
                        <path
                          d="M2,16v4a2,2,0,0,0,2,2H20a2,2,0,0,0,2-2V16"
                          fill="none"
                          stroke="currentColor"
                          stroke-width="2"
                        ></path>
                        <line
                          x1="12"
                          y1="1"
                          x2="12"
                          y2="16"
                          fill="none"
                          stroke="currentColor"
                          stroke-width="2"
                          stroke-linecap="butt"
                        ></line>
                        <polyline
                          points="7 11 12 16 17 11"
                          fill="none"
                          stroke="currentColor"
                          stroke-width="2"
                        ></polyline>
                      </g>
                    </svg>
                    Download Client
                  </router-link>
                </li>
              </ul>
            </ul>
          </div>
        </div>
        <div class="flex-row-reverse ml-3 d-none d-md-flex">
          <router-link
            to="/play"
            class="mb-0 text-white font-weight-bold btn primary"
            >PLAY NOW</router-link
          >
        </div>
        <button
          type="button"
          class="navbar-toggle navbar-toggler ml-3"
          data-bs-toggle="collapse"
          aria-controls="navbarContent"
          aria-expanded="false"
          aria-label="Toggle navigation"
          data-bs-target="#navbarContent"
          id="nav-btn"
        >
          <input
            class="menu-icon"
            type="checkbox"
            id="menu-icon"
            name="menu-icon"
          />
          <label for="menu-icon"></label>
        </button>
      </div>
    </div>
  </nav>
</template>

<script>
import { rankMixin } from "@/mixins/rankMixin.js";

export default {
  mixins: [rankMixin],
  computed: {
    userRank() {
      return this.$store.state.user.privilege.toLowerCase().replace(" ", "-");
    },
  },
  methods: {
    logout() {
      this.$store.dispatch("logout");
      this.$router.push("/");
    },
  },
};
</script>
